// ─────────────────────────────────────────────
// OFFER ENGINE — edit OFFER_RULES to change any offer anytime
// Parameters per rule:
//   minDay / maxDay   : days since lead received (0 = same day)
//   sources           : [] = all sources, ['WH','FB'] = only those
//   days              : [] = any day, [0]=Sun,[1]=Mon,...,[6]=Sat
//   startHour/endHour : 0–23 (endHour is exclusive, e.g. 24 = midnight)
//   offerKey          : unique string used in UI to identify which offer block to show
//   couponCode        : coupon to apply
//   planPeriod        : 'YY' | 'YY2' | 'YY3'
//   whPrice / otherPrice : displayed price strings per source group
// ─────────────────────────────────────────────

export const OFFER_RULES = [
    { id: 1, label: 'Fresh', minDay: 0, maxDay: 0, sources: [], days: [], startHour: 0, endHour: 24, offerKey: 'FRESH', couponCode: '', couponCodeForWH: '', planPeriod: 'YY' },
    { id: 2, label: 'Flash Offer', minDay: 0, maxDay: 1, sources: [], days: [], startHour: 20, endHour: 24, offerKey: 'FLASH_EOD', couponCode: 'OFRFLASH', couponCodeForWH: 'MTFLASH', planPeriod: 'YY' },
    { id: 3, label: 'Sunday Special', minDay: 17, maxDay: 22, sources: [], days: [0], startHour: 0, endHour: 24, offerKey: 'SUNDAY', couponCode: 'OFRSUNSPL', couponCodeForWH: 'MTSUNSPL', planPeriod: 'YY' },
    { id: 4, label: 'Special Offer', minDay: 5, maxDay: 5, sources: [], days: [], startHour: 0, endHour: 24, offerKey: 'D3', couponCode: 'OFRSPLLTD', couponCodeForWH: 'MTSPLLTD', planPeriod: 'YY' },
    { id: 6, label: 'Clearance Offer', minDay: 25, maxDay: 1825, sources: [], days: [], startHour: 0, endHour: 24, offerKey: 'LD25', couponCode: 'OFRPLCLR', couponCodeForWH: 'MTPLCLR', planPeriod: 'YY' },
    { id: 7, label: 'Special Offer', minDay: 5, maxDay: 9999, sources: [], days: [], startHour: 0, endHour: 24, offerKey: 'FDBK_CLRNC', couponCode: 'OFRFDBK', couponCodeForWH: 'MTFDBK', planPeriod: 'YY' },
    { id: 11, label: 'Special Offer', minDay: 14, maxDay: 14, sources: [], days: [0], startHour: 0, endHour: 24, offerKey: 'FDBK_D14SUN', couponCode: 'OFRFDCLR', couponCodeForWH: 'MTFDCLR', planPeriod: 'YY' },
    { id: 8, label: 'Special Offer', minDay: 5, maxDay: 5, sources: [], days: [], startHour: 0, endHour: 24, offerKey: 'D3', couponCode: 'D30OFR', couponCodeForWH: 'MTSPLLTD', planPeriod: 'YY' },
    { id: 9, label: 'Special Offer', minDay: 15, maxDay: 15, sources: [], days: [], startHour: 0, endHour: 24, offerKey: 'D15', couponCode: 'OFRSUNSPL', couponCodeForWH: 'MTSUNSPL', planPeriod: 'YY' },
    { id: 10, label: 'BOGO Offer', minDay: 1, maxDay: 1, sources: [], days: [], startHour: 0, endHour: 24, offerKey: 'SPLBOGO', couponCode: 'AUTOBOGO', couponCodeForWH: 'AUTOBOGO', planPeriod: 'YY2' },

];

// Source groups — add any new source codes here
const WH_FB_SOURCES = ['WH', 'FB', 'WHATSAPP', 'FACEBOOK', 'META'];

const isWHFBSource = (source) => {
    const s = source.toUpperCase();
    return s.startsWith('FB_') || s.endsWith('_WH');
};

const getLeadAgeInDays = (sinceDTStr) => {
    const leadDateStr = sinceDTStr.split(' ')[0]; // "2026-03-13"
    const [ly, lm, ld] = leadDateStr.split('-').map(Number);
    const leadDay = new Date(ly, lm - 1, ld);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return Math.floor((today - leadDay) / (1000 * 60 * 60 * 24));
};
// Returns true if lead is within the D0 flash window:
// Lead must have been received after 6PM yesterday (or today),
// i.e. lead age in hours < 24 AND lead was received at hour >= 18
// Returns true if lead was received between yesterday 6PM → today 6PM
const isInFlashWindow = (sinceDTStr) => {
    const leadDate = new Date(sinceDTStr.replace(' ', 'T'));
    const now = new Date();
    const todayAt6PM = new Date(now);
    todayAt6PM.setHours(18, 0, 0, 0);
    const yesterdayAt6PM = new Date(todayAt6PM);
    yesterdayAt6PM.setDate(yesterdayAt6PM.getDate() - 1);
    return leadDate >= yesterdayAt6PM && leadDate <= todayAt6PM;
};

const is25DaysOlderLead = (sinceDTStr) => {
    const leadDate = new Date(sinceDTStr.replace(' ', 'T'));
    const cutoffDate = new Date('2020-01-01T00:00:00');

    // Must be AFTER 1 Jan 2020
    if (leadDate < cutoffDate) return false;

    const ageDays = getLeadAgeInDays(sinceDTStr);
    if (ageDays < 25) return false;

    return (ageDays - 25) % 360 === 0;
};

const getLeadSource = () => {
    try {
        const allDataRaw = localStorage.getItem('allData');
        if (!allDataRaw) return '';
        const allData = JSON.parse(allDataRaw);
        return (allData?.source || '').toUpperCase();
    } catch { return ''; }
};

// Returns true if lead age falls on cycle: 25, 385, 745, 1105, 1465, 1825
// Formula: starts at day 25, repeats every 360 days, max 5 years (1825)
const isOldLeadCycleDay = (sinceDTStr) => {
    const ageDays = getLeadAgeInDays(sinceDTStr);
    if (ageDays < 25 || ageDays > 1825) return false;
    return (ageDays - 25) % 360 === 0;
};

export const getActiveOffer = (pageName = '') => {
    if (pageName?.toUpperCase() === 'GERP') return null;
    try {
        // ── DEV TESTING ONLY — set localStorage key 'testOffer' to any offerKey (FLASH_EOD, SUNDAY, D3)
        // const testOffer = "FLASH_EOD"
        // if (testOffer) {
        //     const rule = OFFER_RULES.find(r => r.offerKey === testOffer);
        //     if (rule) return { ...rule, displayPrice: rule.otherPrice, isWHFB: true };
        // }

        const allDataRaw = localStorage.getItem('allData');
        if (!allDataRaw) return null;
        const allData = JSON.parse(allDataRaw);
        const sinceDTStr = allData?.sinceDTStr;
        if (!sinceDTStr) return null;

        const source = getLeadSource();
        const isWHFB = isWHFBSource(source);

        const sinceDateStr = sinceDTStr.split(' ')[0];
        const d = new Date();
        // const todayStr = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
        // var isBogo = sinceDateStr === '2026-03-18' && todayStr === '2026-03-19' 
        // var isBogo = false // isWHFB
        const ageDays = getLeadAgeInDays(sinceDTStr);
        var isBogo = ageDays === 7;

        const now = new Date();
        const currentHour = now.getHours();
        const currentDay = now.getDay(); // 0=Sun
        const isD14Sunday = ageDays === 14 && currentDay === 0;


        for (const rule of OFFER_RULES) {
            // FDBK_CLRNC is only shown via forceOfferKey (src=fdbk), never via normal flow
            if (rule.offerKey === 'FDBK_CLRNC') continue;
            // Skip FRESH if flash window is active (flash takes priority on D0 evening)
            if (rule.offerKey === 'FRESH' && isInFlashWindow(sinceDTStr) && currentHour >= 20) continue;
            // Age check — Flash EOD uses strict 6PM window logic, OLD_PL uses cycle logic
            if (rule.offerKey === 'FLASH_EOD') {
                if (!isInFlashWindow(sinceDTStr)) continue;
            } else if (rule.offerKey === 'LD25') {
                if (!is25DaysOlderLead(sinceDTStr)) continue;
            } else if (rule.offerKey === 'OLD_PL') {
                if (!isOldLeadCycleDay(sinceDTStr)) continue;
            } else if (rule.offerKey === 'SPLBOGO') {
                // BOGO is only for leads received on 2026-03-18, shown on day 1 (2026-03-19)
                // const sinceDateStr = sinceDTStr.split(' ')[0];
                // if (sinceDateStr !== '2026-03-18') continue;
                // if (ageDays < rule.minDay || ageDays > rule.maxDay) continue;
                if (!isBogo) continue;
            }
            else {
                if (rule.offerKey === 'SUNDAY' && isD14Sunday) {
                    // Day 14 + Sunday — allow regardless of minDay/maxDay
                } else {
                    if (ageDays < rule.minDay || ageDays > rule.maxDay) continue;
                }
            }
            // Day of week check
            if (rule.days.length > 0 && !rule.days.includes(currentDay)) continue;
            // Hour check
            if (currentHour < rule.startHour || currentHour >= rule.endHour) continue;
            // Source check
            if (rule.sources.length > 0 && !rule.sources.some(s => source.includes(s))) continue;

            if (rule.offerKey != "SPLBOGO" && isBogo) {
                continue;
            }

            return {
                ...rule,
                isWHFB,
                couponCode: isWHFB && rule.couponCodeForWH ? rule.couponCodeForWH : rule.couponCode,
            };
        }

        return null; // No offer matched — show base/default price
    } catch {
        return null;
    }
};

export const getOfferByKey = (offerKey) => {
    const rule = OFFER_RULES.find(r => r.offerKey === offerKey);
    if (!rule) return null;
    const source = getLeadSource();
    const isWHFB = isWHFBSource(source);
    return {
        ...rule,
        isWHFB,
        couponCode: isWHFB && rule.couponCodeForWH ? rule.couponCodeForWH : rule.couponCode,
    };
};

export const getActiveFdbkOffer = () => {
    // D14 + Sunday — use special fdbk offer with 1,999 WH / 4,800 non-WH price
    try {
        const allDataRaw = localStorage.getItem('allData');
        if (allDataRaw) {
            const allData = JSON.parse(allDataRaw);
            const sinceDTStr = allData?.sinceDTStr;
            if (sinceDTStr) {
                const ageDays = getLeadAgeInDays(sinceDTStr);
                const currentDay = new Date().getDay();
                if (ageDays === 14 && currentDay === 0) {
                    const d14rule = OFFER_RULES.find(r => r.offerKey === 'FDBK_D14SUN');
                    if (d14rule) {
                        const source = getLeadSource();
                        const isWHFB = isWHFBSource(source);
                        return {
                            ...d14rule,
                            isWHFB,
                            couponCode: isWHFB && d14rule.couponCodeForWH ? d14rule.couponCodeForWH : d14rule.couponCode,
                        };
                    }
                }
            }
        }
    } catch { }
    const rule = OFFER_RULES.find(r => r.offerKey === 'FDBK_CLRNC');
    if (!rule) return null;
    const source = getLeadSource();
    const isWHFB = isWHFBSource(source);
    return {
        ...rule,
        isWHFB,
        couponCode: isWHFB && rule.couponCodeForWH ? rule.couponCodeForWH : rule.couponCode,
    };
};

export const isFlashOfferOn = () => {
    const offer = getActiveOffer();
    return offer?.offerKey === 'FLASH_EOD';
};

export const isSundayOffer = () => {
    const offer = getActiveOffer();
    return offer?.offerKey === 'SUNDAY';
};